import { SimpleGrid, VStack, Heading, Body } from '@hover/blueprint';
import React from 'react';
import { aboutHoverStatistics } from '../../../constants';
import { IHoverStatistics } from '../../../interfaces/IHoverStatistics';

const AboutHoverStatistic: React.FC = () => (
  <SimpleGrid
    columns={{ base: 2, tablet: 4 }}
    mt={{ base: 400, tablet: 1000 }}
    pb={500}
  >
    {aboutHoverStatistics.map((item: IHoverStatistics) => (
      <VStack
        alignItems={{ base: 'center', desktop: 'flex-start' }}
        spaceing={0}
        mb={{ base: 600, tablet: 0 }}
      >
        <Heading
          color={{ base: 'green.500', tablet: 'green.500' }}
          fontWeight={{ base: 700, tablet: 700 }}
          style={{ marginBottom: 0 }}
          size={{ base: 600, tablet: 700, desktop: 800 }}
        >
          {item.value}
        </Heading>
        <Body
          letterSpacing="1px"
          textAlign={{ base: 'center', desktop: 'left' }}
          maxW={{ base: '140px', desktop: '400px' }}
          size={500}
        >
          {item.title}
        </Body>
      </VStack>
    ))}
  </SimpleGrid>
);

export default AboutHoverStatistic;
